import { Controller, EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import BackgroundsSliderItem from './backgrounds-slider-item';
import { Box } from '@mui/material';
import { ContentSliderProps } from './home-slider';
import { FC } from 'react';
import { getDirection } from '@/lang/utils';
import { pxToRem } from '@/theme/typography';
import { useRouter } from 'next/router';

const ArrowLeftIcon = '/icons/movies-banner/arrow-left.svg';

export const BackgroundsSlider: FC<ContentSliderProps> = ({
  banners,
  swiper,
  handleSwiper,
}) => {
  const { locale } = useRouter();
  const dir = getDirection(locale);

  return (
    <Box
      sx={{
        '.swiper': {
          height: {
            mobile: '165px',
            laptop: pxToRem(704),
          },
        },
        '.swiper-button-prev, .swiper-button-next': {
          width: pxToRem(52),
          height: pxToRem(52),
          borderRadius: pxToRem(12),
          background: `url(${ArrowLeftIcon}) no-repeat center rgba(255, 255, 255, 0.5)`, // TODO: move to palette
          top: pxToRem(150),
          marginTop: pxToRem(0),
          display: {
            mobile: 'none',
            laptop: 'flex',
          },
        },
        '.swiper-button-prev:after, .swiper-button-next:after': {
          content: '""',
        },
        '.swiper-button-prev': {
          left: pxToRem(64),
          transform: dir === 'rtl' ? 'scaleX(-1)' : 'none',
        },
        '.swiper-button-next': {
          right: pxToRem(64),
          transform: dir === 'rtl' ? 'none' : 'scaleX(-1)',
        },
      }}
    >
      <Swiper
        onSwiper={handleSwiper}
        dir={dir}
        speed={600}
        loop
        loopedSlides={banners.length * 2}
        navigation
        modules={[Navigation, Controller, EffectFade]}
        controller={{
          control: swiper,
        }}
        effect='fade'
        allowTouchMove={false}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={banner.id}>
            {/* The first cover is the desktop LCP element — see the priority
                prop on BackgroundsSliderItem. */}
            <BackgroundsSliderItem banner={banner} priority={index === 0} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
